export default __webpack_public_path__ + "static/media/rheinerft2_light.79536e7b.png";